import styled from "styled-components";

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const StyledMainContent = styled.main`
  flex-grow: 1;
  max-width: 1400px;
  margin: 0 auto;
  padding-bottom: 50px;

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

export const Side = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileSocial = styled.div`
  @media (min-width: 769px) {
    display: none;
  }

  margin: 2rem 0;
`;
